import {Fragment} from 'react';
import {Box, CircularProgress, Divider, Grid, Typography} from "@mui/material";
import {CAR_SHIPPING, LTL_FREIGHT, MOVING_SERVICE, PARCEL_PACKAGE} from "../../Utils/Helper";
import {LABEL_DOWNLOAD_URL_PREFIX} from "../../Utils/apiUrl";

export const WordPressMultiConversationChatBotRate = ({
                                                          lng,
                                                          rateInformation,
                                                          service,
                                                          packageRate,
                                                          packageLoading,
                                                          packageError,
                                                          isAbleGetPackageRate,
                                                      }) => {

    console.log('[WordPressMultiConversationChatBot] rateInformation', rateInformation);
    console.log('[WordPressMultiConversationChatBot] service', service);

    const NoRate = () => {
        return (
            <Grid container spacing={2}>
                <Grid size={{xs: 12}}>
                    <Typography sx={{fontWeight: '700', color: 'warning.main', fontSize: '1.1rem'}}>
                        {lng === 'cn'
                            ? '抱歉，根据您当前的选择，系统暂时无法自动生成实时报价。'
                            : 'Instant Quote Unavailable based on your current selections.'}
                    </Typography>
                </Grid>
                <Grid size={{xs: 12}}>
                    <Typography sx={{color: 'text.secondary', lineHeight: 1.6}}>
                        {lng === 'cn'
                            ? '您的请求已成功转交给人工客服团队，请耐心等待。我们将根据当前的物流行情和您的具体需求，进行多渠道资源匹配与比价。'
                            : 'Your request has been successfully forwarded to our support team. Please be patient as we conduct a comprehensive manual assessment and compare multiple shipping channels to meet your specific needs.'}
                    </Typography>
                </Grid>
                <Grid container item spacing={2} size={{xs: 12}} sx={{mt: 1, alignItems: 'center'}}>
                    <Grid size={{xs: 12, sm: 7}}>
                        <Box sx={{pl: 2, borderLeft: '3px solid #eee'}}>
                            <Typography variant="body2" sx={{mb: 1.5}}>
                                <strong>{lng === 'cn' ? '客服热线' : 'Hotline'}:</strong> +1 (604) 998-1888
                            </Typography>
                            <Typography variant="body2" sx={{mb: 1.5}}>
                                <strong>{lng === 'cn' ? '官方邮箱' : 'Email'}:</strong> op@uucargo.ca
                            </Typography>
                            <Typography variant="caption" sx={{color: 'text.disabled', display: 'block', mt: 1}}>
                                {lng === 'cn'
                                    ? '办公时间：周一至周五 9:00 AM - 5:00 PM (PST)'
                                    : 'Office Hours: Mon-Fri 9:00 AM - 5:00 PM (PST)'}
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid size={{xs: 12, sm: 5}} sx={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                        <Box
                            component="img"
                            src="https://storage.googleapis.com/uucargo-resource/image/icon/UUCargoBarcode.png"
                            alt="UU Cargo WeChat"
                            sx={{
                                width: 120,
                                height: 120,
                                borderRadius: 1,
                                border: '1px solid #f0f0f0',
                                p: 0.5,
                                bgcolor: '#fff',
                                boxShadow: '0px 2px 8px rgba(0,0,0,0.06)'
                            }}
                        />
                        <Typography variant="caption" sx={{mt: 1, color: 'text.primary', fontWeight: '600'}}>
                            {lng === 'cn' ? '微信客服扫码' : 'WeChat Support'}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        );
    };

    const PackageRatingFromMovingService = () => {
        return (
            <Grid container spacing={2}>
                {
                    packageLoading ?
                        <Grid size={{xs: 12}}>
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                minHeight: '100px'
                            }}>
                                <CircularProgress/>
                            </Box>
                        </Grid>
                        :
                        (packageError || packageRate?.length === 0) ?
                            <Grid size={{xs: 12}}>
                                <Typography>
                                    {lng === 'cn' ? '根据您当前的选择，您也可以考虑使用我们的快递服务作为替代运输方案。不过，系统无法实时生成报价。' : "Based on your current selections, you may also consider our courier service as an alternative shipping method. However, we cannot provide you with an immediate quote."}
                                </Typography>
                            </Grid>
                            :
                            <>
                                <Grid size={{xs: 12}}>
                                    <Typography sx={{fontWeight: '600'}}>
                                        {lng === 'cn' ? '备选方案：包裹快递' : "Alternative Option: Courier Service"}
                                    </Typography>
                                </Grid>
                                <Grid size={{xs: 12}}>
                                    <Typography>
                                        {lng === 'cn' ? '根据您当前的选择，您也可以考虑使用我们的快递服务作为替代运输方案。' : "Based on your current selections, you may also consider our courier service as an alternative shipping method."}
                                    </Typography>
                                </Grid>
                                <Grid size={{xs: 4}}>
                                    <Typography>
                                        {lng === 'cn' ? '承运商' : "Carrier"}
                                    </Typography>
                                </Grid>
                                <Grid size={{xs: 4}}>
                                    <Typography>
                                        {lng === 'cn' ? '运输天数' : "Transit Days"}
                                    </Typography>
                                </Grid>
                                <Grid size={{xs: 4}}>
                                    <Typography>
                                        {lng === 'cn' ? '费用' : "Cost"}
                                    </Typography>
                                </Grid>
                                <Grid size={{xs: 12}}>
                                    <Divider/>
                                </Grid>
                                {
                                    packageRate?.slice(0, 3)?.map((rate, index) => (
                                        <Fragment key={index}>
                                            <Grid size={{xs: 4}}>
                                                <Box>
                                                    <img src={`${LABEL_DOWNLOAD_URL_PREFIX}${rate?.icon_uri}`}
                                                         alt="icon"
                                                         width='40px'/>
                                                </Box>
                                            </Grid>
                                            <Grid size={{xs: 4}}>
                                                <Typography>
                                                    {rate?.shipRange || '2 - 10'} days
                                                </Typography>
                                            </Grid>
                                            <Grid size={{xs: 4}}>
                                                <Typography>
                                                    $ {(+rate?.finalTotalAmount?.value)?.toFixed(2)} {rate?.finalTotalAmount?.currency}
                                                </Typography>
                                            </Grid>
                                        </Fragment>
                                    ))
                                }
                            </>
                }
            </Grid>
        )
    }

    const listRateWithServiceCode = (rateInformation, service) => {
        switch (service?.code) {
            case PARCEL_PACKAGE?.code:
                return (
                    <>
                        {
                            rateInformation?.length === 0 ?
                                <Grid size={{xs: 12}}>
                                    <NoRate/>
                                </Grid>
                                :
                                rateInformation?.map((each, index) => (
                                    <Fragment key={index}>
                                        <Grid size={{xs: 4}}>
                                            <Box>
                                                <img src={`${LABEL_DOWNLOAD_URL_PREFIX}${each?.icon_uri}`} alt="icon"
                                                     width='40px'/>
                                            </Box>
                                        </Grid>
                                        <Grid size={{xs: 4}}>
                                            <Typography>
                                                {each?.shipRange || '2 - 10'} {lng === 'cn' ? '天' : 'day(s)'}
                                            </Typography>
                                        </Grid>
                                        <Grid size={{xs: 4}}>
                                            <Typography>
                                                $ {(+each?.finalTotalAmount?.value)?.toFixed(2)} {each?.finalTotalAmount?.currency}
                                            </Typography>
                                        </Grid>
                                    </Fragment>
                                ))
                        }
                    </>
                );
            case LTL_FREIGHT?.code:
                return (
                    <>
                        {
                            rateInformation?.length === 0 ?
                                <Grid size={{xs: 12}}>
                                    <NoRate/>
                                </Grid>
                                :
                                rateInformation?.map((each, index) => (
                                    <Fragment key={index}>
                                        <Grid size={{xs: 4}}>
                                            <Box>
                                                <img src={`${LABEL_DOWNLOAD_URL_PREFIX}${each?.icon_uri}`} alt="icon"
                                                     width='40px'/>
                                            </Box>
                                        </Grid>
                                        <Grid size={{xs: 4}}>
                                            <Typography>
                                                {each?.shipRange || '2 - 10'} {lng === 'cn' ? '天' : 'day(s)'}
                                            </Typography>
                                        </Grid>
                                        <Grid size={{xs: 4}}>
                                            <Typography>
                                                $ {(+each?.finalTotal)?.toFixed(2)} {each?.currency}
                                            </Typography>
                                        </Grid>
                                    </Fragment>
                                ))
                        }
                    </>
                );
            case MOVING_SERVICE?.code:
                return (
                    <>
                        {
                            +rateInformation?.totalCharge === 0 ?
                                <Grid size={{xs: 12}}>
                                    <NoRate/>
                                </Grid>
                                :
                                <Fragment>
                                    {/*<Grid size={{xs: 12}}>*/}
                                    {/*    <Typography sx={{textAlign: 'center', fontSize: '20px'}}>*/}
                                    {/*        {lng === 'cn' ? '您的搬家报价已初步生成！' : 'Your Moving Quote has been preliminarily generated!'}*/}
                                    {/*    </Typography>*/}
                                    {/*    <Typography>*/}
                                    {/*        {lng === 'cn' ? '为了确保报价准确并确认您的服务细节，我们的运营专员正在进行人工审核。我们将很快通过邮件或电话与您取得联系，请保持通讯畅通。' : 'To ensure accuracy and finalize your service details, our Operator is currently conducting a manual review. We will get back to you shortly via email or phone. Please keep your communication lines open.'}*/}
                                    {/*    </Typography>*/}
                                    {/*    <Typography>*/}
                                    {/*        {lng === 'cn' ? '如果您有任何疑问，请随时通过电话 1-604-998-1888 或发送邮件至 op@uucargo.ca 直接联系 UUCargo。' : 'If you have any questions, feel free to contact UUCargo directly via phone at 1-604-998-1888 or email at op@uucargo.ca.'}*/}
                                    {/*    </Typography>*/}
                                    {/*</Grid>*/}
                                    <Grid size={{xs: 6}}>
                                        <Typography sx={{fontSize: '16px', textAlign: 'left'}}>
                                            {lng === 'cn' ? '小计' : "Subtotal"}
                                        </Typography>
                                    </Grid>
                                    <Grid size={{xs: 6}}>
                                        <Typography sx={{fontSize: '16px', textAlign: 'right'}}>
                                            $ {(+rateInformation?.totalCharge).toFixed(2)}
                                        </Typography>
                                    </Grid>
                                    <Grid size={{xs: 6}}>
                                        <Typography sx={{fontSize: '16px', textAlign: 'left'}}>
                                            {lng === 'cn' ? '税费' : "Tax"}
                                        </Typography>
                                    </Grid>
                                    <Grid size={{xs: 6}}>
                                        <Typography sx={{fontSize: '16px', textAlign: 'right'}}>
                                            $ {(+rateInformation?.taxCharge || 0).toFixed(2)}
                                        </Typography>
                                    </Grid>
                                    <Grid size={{xs: 12}}>
                                        <Divider/>
                                    </Grid>
                                    <Grid size={{xs: 6}}>
                                        <Typography sx={{fontSize: '16px', textAlign: 'left'}}>
                                            {lng === 'cn' ? '总计' : "Total"}
                                        </Typography>
                                    </Grid>
                                    <Grid size={{xs: 6}}>
                                        <Typography sx={{fontSize: '16px', textAlign: 'right'}}>
                                            $ {(+rateInformation?.totalChargeWithTaxes)?.toFixed(2)}
                                        </Typography>
                                    </Grid>
                                    <Grid size={{xs: 12}}>
                                        <br/>
                                        <Typography sx={{fontSize: '16px', textAlign: 'left'}}>
                                            {lng === 'cn' ? '价格说明' : "Price Disclaimer"}
                                        </Typography>
                                        <Typography sx={{fontSize: '16px', textAlign: 'left'}}>
                                            {lng === 'cn' ? '显示的搬家价格为系统预估价格，仅供参考。' : "The moving price is a system-generated estimate for reference only."}
                                        </Typography>
                                        <br/>
                                        <Typography sx={{fontSize: '16px', textAlign: 'left'}}>
                                            {lng === 'cn' ? '搬家费用会根据多项因素动态变化，包括但不限于：' : "Moving costs may vary based on multiple factors, including but not limited to:"}
                                        </Typography>
                                        <Typography sx={{fontSize: '16px', textAlign: 'left'}}>
                                            -{lng === 'cn' ? '实际取件与送达地址（是否偏远地区）' : "Exact pickup and delivery locations (remote areas may affect pricing)"}
                                        </Typography>
                                        <Typography sx={{fontSize: '16px', textAlign: 'left'}}>
                                            -{lng === 'cn' ? '物品清单的完整度、体积、重量及特殊物品' : "Completeness of the item list, total volume, weight, and special items"}
                                        </Typography>
                                        <Typography sx={{fontSize: '16px', textAlign: 'left'}}>
                                            -{lng === 'cn' ? '是否需要打板、拆装、上楼、电梯预约等额外服务' : "Additional services such as palletizing, disassembly/reassembly, stairs, elevator booking, etc."}
                                        </Typography>
                                        <Typography sx={{fontSize: '16px', textAlign: 'left'}}>
                                            -{lng === 'cn' ? '当期人工、运输资源及路线安排' : "Current labor availability, transportation resources, and routing conditions"}
                                        </Typography>
                                        <br/>
                                        <Typography sx={{fontSize: '16px', textAlign: 'left'}}>
                                            {lng === 'cn' ? '在未获取完整信息前，系统无法给出准确报价。 最终价格请以人工确认后的正式报价为准。如需准确价格，欢迎提交询价或直接联系我们的客服团队。' : "Final pricing will be confirmed manually and may differ from the estimate shown. Please submit an inquiry or contact our team for an accurate quote."}
                                        </Typography>
                                    </Grid>
                                </Fragment>
                        }
                    </>
                );
            case CAR_SHIPPING?.code:
                return (
                    <>
                        {
                            +rateInformation?.finalTotal === 0 ?
                                <Grid size={{xs: 12}}>
                                    <NoRate/>
                                </Grid>
                                :
                                <Fragment>
                                    <Grid size={{xs: 6}}>
                                        <Typography sx={{fontSize: '16px', textAlign: 'left'}}>
                                            {lng === 'cn' ? '小计' : "Subtotal"}
                                        </Typography>
                                    </Grid>
                                    <Grid size={{xs: 6}}>
                                        <Typography sx={{fontSize: '16px', textAlign: 'right'}}>
                                            $ {(+rateInformation?.totalCharge || 0).toFixed(2)}
                                        </Typography>
                                    </Grid>
                                    <Grid size={{xs: 6}}>
                                        <Typography sx={{fontSize: '16px', textAlign: 'left'}}>
                                            {lng === 'cn' ? '税费' : "Tax"}
                                        </Typography>
                                    </Grid>
                                    <Grid size={{xs: 6}}>
                                        <Typography sx={{fontSize: '16px', textAlign: 'right'}}>
                                            $ {(+rateInformation?.taxCharge || 0).toFixed(2)}
                                        </Typography>
                                    </Grid>
                                    <Grid size={{xs: 12}}>
                                        <Divider/>
                                    </Grid>
                                    <Grid size={{xs: 6}}>
                                        <Typography sx={{fontSize: '16px', textAlign: 'left'}}>
                                            {lng === 'cn' ? '总计' : "Total"}
                                        </Typography>
                                    </Grid>
                                    <Grid size={{xs: 6}}>
                                        <Typography sx={{fontSize: '16px', textAlign: 'right'}}>
                                            $ {(+rateInformation?.finalTotal || 0).toFixed(2)}
                                        </Typography>
                                    </Grid>
                                    <Grid size={{xs: 12}}>
                                        <br/>
                                    </Grid>
                                    <Grid size={{xs: 12}}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                textAlign: 'left',
                                                fontWeight: '600'
                                            }}>
                                            {lng === 'cn' ? '附加费' : "Additional Charges"}
                                        </Typography>
                                    </Grid>
                                    <Grid size={{xs: 12}}>
                                        <Typography sx={{textAlign: 'left'}}>
                                            {lng === 'cn' ? '预约取车：' : "Scheduled Pickup:"} {+rateInformation?.pickupCharge > 0 ? `$ ${(+rateInformation?.pickupCharge)?.toFixed(2)}` : lng === 'cn' ? '待定' : 'TBD'}
                                        </Typography>
                                        <Typography sx={{textAlign: 'left'}}>
                                            {lng === 'cn' ? '预约送车：' : "Scheduled Delivery:"} {+rateInformation?.deliverCharge > 0 ? `$ ${(+rateInformation?.pickupCharge)?.toFixed(2)}` : lng === 'cn' ? '待定' : 'TBD'}
                                        </Typography>
                                    </Grid>
                                    <Grid size={{xs: 12}}>
                                        <br/>
                                    </Grid>
                                    <Grid>
                                        <Typography
                                            sx={{
                                                textAlign: 'left',
                                                wordWrap: 'break-word',
                                                wordBreak: 'break-word',
                                                whiteSpace: 'normal'
                                            }}>
                                            {
                                                lng === 'cn' ? '备注：以上总额仅为“航站楼到航站楼的基础报价。其他选定的物流服务费用——包括从所在地到航站楼的提货费，以及从航站楼到所在地的送货费——将另行计算并计入最终总额' :
                                                    'Note: The total above represents the terminal-to-terminal base quote only. Additional charges for logistics services—including local pickup to the terminal and local delivery from the terminal—will be calculated and applied to the final total.'
                                            }
                                        </Typography>
                                    </Grid>
                                </Fragment>
                        }
                    </>
                )
                    ;
            default:
                return ""
        }
    }

    return (
        <Grid container spacing={2}>
            <Grid size={{xs: 12}}>
                <Grid container spacing={0}>
                    {
                        listRateWithServiceCode(rateInformation, service)
                    }
                </Grid>
            </Grid>
            {
                isAbleGetPackageRate &&
                <>
                    <Grid size={{xs: 12}}>
                        <Divider/>
                    </Grid>
                    <Grid size={{xs: 12}}>
                        <Typography sx={{fontWeight: '600'}}>
                            {lng === 'cn' ? '替代选择：快递服务' : "Alternative Option: Courier Service"}
                        </Typography>
                    </Grid>
                    <Grid size={{xs: 12}}>
                        <PackageRatingFromMovingService/>
                    </Grid>
                </>
            }
            {
                service?.code !== MOVING_SERVICE?.code &&
                <Grid size={{xs: 12}}>
                    <Typography sx={{fontSize: '14px', textAlign: 'right'}}>
                        {lng === 'cn' ? '预估费用仅供参考。' : "The estimated cost is for reference only."}
                    </Typography>
                </Grid>
            }
        </Grid>
    )
}
